export default "__VITE_PUBLIC_ASSET__0c6c9b8a__"